import React, { useEffect, useState, useRef } from "react"
import {
  loadNextPage,
  setProductListLoadStatus,
} from "components/Stacker/actions/StackerActions"
import isMobile from "components/Stacker/utils/device-check"
import classNames from "classnames"
import Loader from "components/Stacker/components/Loader/Loader"
import PropTypes from "prop-types"
import StackerInfiniteScroll from "../Common/StackerInfiniteScroll/StackerInfiniteScroll"
import ProductReviewSelection from "../ProductReviewSelection/ProductReviewSelection"
import "./ProductList.scss"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { getDY_SR } from "stackerConfig"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { useCallback, useLayoutEffect } from "react"

export function Header({ children }) {
  return <div className="product_list-header">{children}</div>
}

Header.propTypes = {
  children: PropTypes.any,
}

function Body({ children }) {
  return <>{children}</>
}

Body.propTypes = {
  children: PropTypes.any,
}

function Footer({ children }) {
  return <div className="product_list-footer">{children}</div>
}

Footer.propTypes = {
  children: PropTypes.any,
}

function ProductList({ columns, pageSize, productType, children }) {
  //const [loadedImages, setLoadedImages] = useState(0)
  const dispatch = useDispatch()
  const containerRef = useRef()
  const gridRef = useRef()
  //const [containerHeight, setContainerHeight] = useState(0)
  //const [heightRange, setHeightRange] = useState(1500)

  const expanded = useSelector(
    (state) => state.amuletStacker.productListExpanded
  )
  const isFilterOpen = useSelector((state) => state.stacker.isFilterOpen)
  const isProductListLoaded = useSelector(
    (state) => state.stacker.isProductListLoaded
  )
  const pagination = useSelector((state) => {
    return state.stacker.pagination
  })
  const paginationRef = useRef(pagination)
  const isReviewing = useSelector((state) => state.stacker.isReviewing)
  const selected = useSelector(
    (state) => state.stacker.addedStack,
    shallowEqual
  )
  const isNoResultView = useSelector(
    (state) => state.search?.meta?.isNoResultView ?? false
  )
  const [isLoading, setIsLoading] = useState(false)

  useLayoutEffect(() => {
    console.log(pagination)
    paginationRef.current = pagination
  }, [pagination.currentPage, pagination.totalPages])

  useEffect(() => {
    const loading = !isProductListLoaded && !isNoResultView
    if (loading) {
      console.log("loading ")
    }
    if (isLoading !== loading) {
      setIsLoading(loading)
    }
  }, [isLoading, isNoResultView, isProductListLoaded])

  // useEffect(() => {
  //   setContainerHeight(containerRef.current.offsetHeight)
  // }, [containerRef])

  // useEffect(() => {
  //   setHeightRange(gridRef.current.offsetHeight - containerHeight - 750)
  // }, [gridRef, containerHeight])

  // useEffect(() => {
  //   //TODO: loadedImages never changes, review if this is actually needed or usefull
  //   if (loadedImages === pageSize) {
  //     dispatch(setProductListLoadStatus)
  //   }

  //   // if (isProductListLoaded && !prevProps.isProductListLoaded) {
  //   //   containerRef.scrollTop = 0
  //   // }
  // }, [dispatch, loadedImages, pageSize])

  const loadMoreProducts = useCallback(() => {
    if (
      paginationRef.current.currentPage + 1 <
      paginationRef.current.totalPages
    ) {
      dispatch(loadNextPage())
    }
  }, [dispatch])

  const header = children.find((child) => child.type === Header)
  const body = children.find((child) => child.type === Body)
  const footer = children.find((child) => child.type === Footer)

  const headerChild = header && React.cloneElement(header.props.children, {})
  const bodyChild = body && React.cloneElement(body.props.children, {})
  const footerChild = footer && React.cloneElement(footer.props.children, {})

  const containerClass = classNames(
    "product_list-stage",
    // "h-100",
    productType,
    {
      reviewing: isReviewing,
      stacking: !isReviewing,
    }
  )

  const productListClass = classNames(
    "product_list",
    "product_list-stacker",
    "position-absolute",
    "h-100",
    "w-100",
    { expanded },
    { "filter-open": isFilterOpen }
  )

  const gridClass = classNames(
    "product_list-body chooser-grid flex-grow-1",
    `columns-${columns}`,
    { "d-none": !isProductListLoaded }
  )

  const containerHeight = containerRef.current
    ? containerRef.current.offsetHeight
    : 0
  const heightRange = gridRef.current
    ? gridRef.current.offsetHeight - containerHeight - 750
    : 1500

  const el = shadowDOM.getElementsByClassName("product_list-body-list")[0]
  const widthRange = el ? el.scrollWidth : 0

  return (
    <div
      className={containerClass}
      //style={{ position: "absolute", width: "100%", left: "0%" }}
    >
      <section id="product_list" className={productListClass}>
        <React.Fragment>
          <div className="product_list-header">{headerChild}</div>
          <StackerInfiniteScroll
            handleRefresh={loadMoreProducts}
            heightRange={!isMobile() ? heightRange : widthRange}
            offset={1000}
          >
            {isNoResultView && (
              <div className="no-results-found">No Results Found</div>
            )}
            {isLoading && <Loader />}
            <div className={gridClass} ref={containerRef}>
              <div className="chooser-grid-container" ref={gridRef}>
                {bodyChild}
              </div>
            </div>
          </StackerInfiniteScroll>
          <div className="product_list-footer">{footerChild}</div>
          {isFilterOpen && <div className="product_list-body-overlay" />}
        </React.Fragment>
      </section>
      <ProductReviewSelection productType={productType} selected={selected} />
    </div>
  )
}

ProductList.propTypes = {
  columns: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  productType: PropTypes.string.isRequired,
  children: PropTypes.any,
}

ProductList.Header = Header
ProductList.Footer = Footer
ProductList.Body = Body
export default ProductList
